import { NavigateFunction } from "react-router-dom";

let _navigate: NavigateFunction | null = null;

export const setNavigate = (fn: NavigateFunction) => {
  _navigate = fn;
};

export const navigateTo = (path: string) => {
  _navigate?.(path);
};
